export default __webpack_public_path__ + "static/media/xray.dd941630.png";